export const mapDtoToGridObject = (product) => ({
  ...product,
  id: product.mpn,
  totalImages: [product.image, ...product.additional_images],
});

export const mapDtoToGrid = (products) => products.map((pr) => mapDtoToGridObject(pr));
